const React = require("react");
const HttpContext = React.createContext({});
module.exports = HttpContext;
